export const entityDataReportButtons = {
  dataDownloadExcel: {
    rpp: '/COROTA/PatientListClasif',
    pts: 0,
    fmt: 3,
    dn: '',
    rp: '',
  },
  dataRenderReport: {
    rpp: '/COROTA/PatientListClasif',
    pts: 0,
    z: 100,
    htmf: false,
    fmt: 2,
    dl: false,
    dn: '',
    rp: '',
  },
};
